/**
 * @class service_v3sFeedbackService
 * @memberOf v3sWbtPlayerApp:exercise
 */
angular.module('v3sWbtPlayerApp').factory('v3sFeedbackService', ["v3sAlertService", "v3sI18nService", "v3sExerciseStatus", function (v3sAlertService, v3sI18nService, v3sExerciseStatus) {
    var feedback = null;
    var allFeedbacks = [];
    var summary = null;
    var feedbackblocks = null;
    var feedbackScope = null;

    function setFeedbackScope(fbScope) {
        feedbackScope = fbScope;
    }

    /**
     * Setzt das summarische Feedback
     * @memberOf v3sWbtPlayerApp:exercise.service_v3sFeedbackService
     * @param {string} sum
     */
    function setSummary(sum) {
        summary = sum;
    }

    /**
     * Setzt die Feedbackblocks
     * @memberOf v3sWbtPlayerApp:exercise.service_v3sFeedbackService
     * @param {array} fbblocks
     */
    function setFeedbackBlock(fbblocks) {
        feedbackblocks = fbblocks;
    }

    /**
     * Prüft, ob gerade eins oder mehrere Feedbacks angezeigt werden.
     *
     * @memberOf v3sWbtPlayerApp:exercise.service_v3sFeedbackService
     */
    function isShown() {
        if (feedback && feedback.$isShown && !hasAuthorMessage()) {
            return true;
        }

        if (allFeedbacks) {
            for (var i = 0; i < allFeedbacks.length; i++) {
                if (allFeedbacks[i].$isShown) {
                    return true;
                }
            }
        }

        return false;
    }

    /**
     * Versteckt das Feedbackfenster
     * @memberOf v3sWbtPlayerApp:exercise.service_v3sFeedbackService
     */
    function hideFeedback() {
        if (!!feedback) {
            feedback.hide();
        }

        if (allFeedbacks) {
            var allFeedbacksCopy = allFeedbacks;
            allFeedbacks = [];

            for (var i = 0; i < allFeedbacksCopy.length; i++) {
                allFeedbacksCopy[i].hide();
            }
        }
    }
    /**
     * Zeigt das Feedbackfenster an und spielt ggf. das Audiofeedback ab.
     * Das Feedbackfenster ist eine {@link http://mgcrea.github.io/angular-strap/#/tooltips Angular-Strap Tooltip-Direktive}
     * @memberOf v3sWbtPlayerApp:exercise.service_v3sFeedbackService
     */
    function showFeedback(status, exerciseType, completed, remainingAttempts, timeout) {
        hideFeedback();

        //get the actual feedback message
        var feedbackmsg = null;
        var thetry = (remainingAttempts <= 0) ? "final" : "initial";
        var audio = null;

        if (remainingAttempts > 0) {
            if (!!feedbackblocks[0][status.message]) {
                feedbackmsg = feedbackblocks[0][status.message].text
                audio = feedbackblocks[0][status.message].audio;
            }
        } else {
            if (!!feedbackblocks[feedbackblocks.length - 1][status.message]) {
                feedbackmsg = feedbackblocks[feedbackblocks.length - 1][status.message].text;
                audio = feedbackblocks[feedbackblocks.length - 1][status.message].audio;
            }
        }
        if (!feedbackmsg) {
            feedbackmsg = v3sI18nService.getText([
                "exercises.feedbacks." + exerciseType + "." + thetry + "." + status.message, //Exercise try specific feedback
                "exercises.feedbacks." + exerciseType + "." + status.message, //Exercise specific feedback
                "exercises.feedbacks.general." + thetry + "." + status.message, //general try specific feedback
                "exercises.feedbacks.general." + status.message //general feedback
            ]);
        }

        var msgType;
        var msgTitle = !!timeout ? v3sI18nService.getText('exercises.feedbacks.general.title_timeout') : v3sI18nService.getText('exercises.feedbacks.general.title');

        if (status == v3sExerciseStatus.CORRECT) {
            msgType = "success";
        } else {
            if (status == v3sExerciseStatus.NO_ANSWER) {
                msgType = "info";
            } else {
                msgType = "danger";
                if (!completed && remainingAttempts > 0) {
                    feedbackmsg += " <span class='remaining-attempts'>";

                    if (remainingAttempts == 1) {
                        feedbackmsg += v3sI18nService.getText("exercises.feedbacks.general.one_try_left");
                    } else {
                        feedbackmsg += v3sI18nService.getText("exercises.feedbacks.general.n_tries_left", { remainingTries: remainingAttempts });
                    }

                    feedbackmsg += "</span>"
                }
            }
        }

        if (!!timeout) {
            msgType += "-timeout";
        }

        //Final try and there is a summary
        if (completed && !!summary && status != v3sExerciseStatus.NO_ANSWER) {
            feedbackmsg = feedbackmsg + " <p>" + summary + "</p>";
        }

        feedback = v3sAlertService({
            title: msgTitle,
            content: feedbackmsg,
            html: true,
            placement: 'top-right-float',
            container: '#feedbacks',
            type: msgType,
            audio: audio,
            scope: feedbackScope
        });
    };

    /**
     * Zeigt alle Feedbackfenster an.
     * @memberOf v3sWbtPlayerApp:exercise.service_v3sFeedbackService
     */
    function showAllFeedbacks() {
        if (!feedbackblocks || feedbackblocks.length == 0) {
            return true;
        }

        // Feedback wird schon angezeigt
        if (isShown()) {
            return false;
        }

        hideFeedback();

        allFeedbacks = [];

        var hadSummary = false;
        var msgTitle = v3sI18nService.getText('exercises.feedbacks.general.title');

        for (var completed = 0; completed < 2; completed++){
            for (var status in v3sExerciseStatus) {
                var statusObj = v3sExerciseStatus[status];
                var feedbackmsg = getAuthorMessage(statusObj, completed);

                if (feedbackmsg) {
                    var msgType;
                    if (statusObj == v3sExerciseStatus.CORRECT) {
                        msgType = "success";
                    } else {
                        if (statusObj == v3sExerciseStatus.NO_ANSWER) {
                            msgType = "info";
                        } else {
                            msgType = "danger";
                            if (!completed) {
                                feedbackmsg += " <span>";
                                feedbackmsg += v3sI18nService.getText("exercises.feedbacks.general.n_tries_left", { remainingTries: "x" });
                                feedbackmsg += "</span>"
                            }
                        }
                    }

                    //Final try and there is a summary
                    if ((completed || msgType === "success") && summary) {
                        feedbackmsg = feedbackmsg + " <p>" + summary + "</p>";
                        hadSummary = true;
                    }

                    allFeedbacks.push(v3sAlertService({
                        title: msgTitle,
                        content: feedbackmsg,
                        placement: 'top-right-float',
                        container: '#feedbacks',
                        type: msgType,
                        audio: null,
                        duration: -1
                    }));
                }
            }
        }

        // Summarisches Feedback anzeigen, falls noch nicht geschehen
        if (summary && !hadSummary) {
            allFeedbacks.push(v3sAlertService({
                title: v3sI18nService.getText("exercises.feedbacks.general.summary_feedback"),
                content: "<p>" + summary + "</p>",
                placement: 'top-right-float',
                container: '#feedbacks',
                type: "info",
                audio: null,
                duration: -1
            }));
        }

        return true;
    };

    function hasAuthorMessage() {
        if (summary) {
            return true;
        }

        for (var completed = 0; completed < 1; completed++) {
            for (var status in v3sExerciseStatus) {
                var statusObj = v3sExerciseStatus[status];

                if (getAuthorMessage(statusObj, completed)) {
                    return true;
                }
            }
        }

        return false;
    }

    function getAuthorMessage(status, finalAttempt) {
        if (finalAttempt) {
            if (feedbackblocks[feedbackblocks.length - 1][status.message]) {
                return feedbackblocks[feedbackblocks.length - 1][status.message].text;
            }
        } else {
            if (feedbackblocks[0][status.message]) {
                return feedbackblocks[0][status.message].text
            }
        }

        return null;
    }

    return {
        setFeedbackScope : setFeedbackScope,
        showFeedback: showFeedback,
        showAllFeedbacks: showAllFeedbacks,
        hideFeedback: hideFeedback,
        setFeedbackBlock : setFeedbackBlock,
        setSummary: setSummary,
        isShown: isShown
    }
}]);
